import React from 'react';
import { useEffect, useState } from 'react';
import { Col, Form, Row, Button, InputGroup, Spinner, FormLabel, Card } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { advocateDetailsAction, formChangedAction } from '../../actions/index';
import EnlargableTextbox from 'components/common/EnlargableTextbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { countryListAPI } from 'actions/CountryMaster/countryMasterAction';
import { toast } from 'react-toastify';
import { stateListAPI } from 'actions/StateMaster/stateMasterAction';
import {
  advocateEmailMobileValidationAPI,
  verifyEmailMobileNoAPI,
  viewAdvocateDetailAPI
} from 'actions/AdvocateRegistration/advocateRegistrationAction';
import ConfirmationModal from 'components/common/Modal/ConfirmationModal';
import DeleteImageConfirmationModal from 'components/common/Modal/DeleteImageConfirmationModal';
import Moment from "moment";
import FalconComponentCard from 'components/common/FalconComponentCard';
import loader from '../../assets/img/loader.svg'

export const ProfileDetail = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [currentCheck, setCurrentCheck] = useState('');
  const [showModal, setShowModal] = useState('');
  const [emailMobileExistsMessage, setEmailMobileExistsMessage] = useState('');

  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
  const headers = {
    Authorization: `Bearer ${JSON.parse(token).value}`
  };

  useEffect(() => {
    viewAdvocateProfileDetail();
    getCountriesList();
  }, []);

  const advocateDetailsReducer = useSelector(
    state => state.rootReducer.advocateDetailsReducer
  );
  var advocateData = advocateDetailsReducer.advocateDetails;

  const advocateDetailsErrorReducer = useSelector(
    state => state.rootReducer.advocateDetailsErrorReducer
  );
  const advocateError = advocateDetailsErrorReducer.advocateDetailsError;

  const formChangedReducer = useSelector(
    state => state.rootReducer.formChangedReducer
  );
  var formChangedData = formChangedReducer.formChanged;

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [formHasError, setFormError] = useState(false);
  const [perPage, setPerPage] = useState(15);
  const [oldEmail, setOldEmail] = useState('');
  const [oldMobileNo, setOldMobileNo] = useState('');
  const [isEmailChanged, setIsEmailChanged] = useState(false);
  const [isMobileNoChanged, setIsMobileNoChanged] = useState(false);
  const [emailErr, setEmailErr] = useState('');
  const [mobileNoErr, setMobileNoErr] = useState('');
  const [deleteModal, setDeleteModal] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);


  useEffect(() => {
    if (advocateData && advocateData.stateCode && !$('#txtState').val()) {
      getStatesList(advocateData.countryCode);
    }
  }, [advocateData]);

  const getCountriesList = async (page, size = perPage) => {
    const data = {
      pageNumber: page,
      pageSize: size,
      SearchText: '',
      isDropDown: true
    };
    await dispatch(
      countryListAPI(
        data,
        res => {
          let countryData = [];
          if (res.data.data.countryList.length > 0)
            res.data.data.countryList.forEach(country => {
              countryData.push({
                key: country.countryName,
                value: country.countryCode
              });
            });
          setCountryList(countryData);
        },
        err => {
          toast.error(err?.data?.message || 'Error fetching countries', {
            theme: 'colored',
            autoClose: 10000
          });
          setCountryList([]);
        },
        headers
      )
    );
  };

  const getStatesList = async (selectCountryCode) => {
    const data = {
      countryCode: selectCountryCode,
      isDropDown: true,
      isList: false
    };
    await dispatch(
      stateListAPI(
        data,
        res => {
          let stateData = [];
          if (res && res.length > 0) {
            res.forEach(state => {
              stateData.push({
                key: state.stateName,
                value: state.stateCode
              });
            });
            setStateList(stateData);
          } else {
            setStateList([]);
          }
        },
        err => {
          setStateList([]);
        }
      )
    );
  };

  const handleFieldChange = e => {
    dispatch(
      advocateDetailsAction({
        ...advocateData,
        [e.target.name]: e.target.value
      })
    );

    if (e.target.name == 'countryCode') {
      if (e.target.value == '') setStateList([]);
      else getStatesList(e.target.value);
    }
    if (e.target.name === 'email') {
      setIsEmailChanged(
        e.target.value.toLowerCase() !== oldEmail.toLowerCase()
      );
    }
    if (e.target.name === 'mobileNo') {
      setIsMobileNoChanged(e.target.value !== oldMobileNo);
    }

    if (e.target.name == 'advocatePicFile') {
      if (e.target.files[0]) {
            const imageURL = URL.createObjectURL(e.target.files[0]); 
            setImagePreview(imageURL)
        dispatch(
          advocateDetailsAction({
            ...advocateData,
            advocatePicFile: e.target.files[0],
            advocatePicFileURL: URL.createObjectURL(e.target.files[0])
          })
        );
      } else {
        dispatch(
          advocateDetailsAction({
            ...advocateData,
            advocatePicFile: null,
            advocatePicFileURL: ''
          })
        );
      }
    }
    if (advocateData.encryptedAdvocateCode) {
      dispatch(
        formChangedAction({
          ...formChangedData,
          advocateUpdate: true
        })
      );
    }
  };

  const removeUploadFile = () => {
    $('#advocatePicFile').val(null);
    dispatch(
      advocateDetailsAction({
        ...advocateData,
        advocatePicFile: '',
        advocatePicFileURL: '',
        IsDeleteAdvocatePicFile: true
      })
    );
    dispatch(
      formChangedAction({
        ...formChangedData,
        advocateUpdate: true
      })
    );
    $('#btnSave').attr('disabled', false);
    setDeleteModal(false);
  };

  const viewAdvocateProfileDetail = async () => {
    const requestData = {
      EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode')
    };
    await dispatch(
      viewAdvocateDetailAPI(
        requestData,
        res => {
          setIsLoading(false);
          dispatch(advocateDetailsAction(res.data.data));
          setOldEmail(res.data.data.email);
          setOldMobileNo(res.data.data.mobileNo);
        },
        err => {
          setIsLoading(false);
          console.log(err?.data.message);
        },
        headers
      )
    );
  };

  const checkMobileNo = async () => {
    if (EmailOrMobileNoValidation()) {
      const requestData = {
        email: '',
        phoneNumber: advocateData.mobileNo,
        encryptedAdvocateCode: advocateData.encryptedAdvocateCode
          ? advocateData.encryptedAdvocateCode
          : '',
        isUpdate: advocateData.encryptedAdvocateCode ? true : false
      };
      setIsLoading(true);
      dispatch(
        advocateEmailMobileValidationAPI(
          requestData,
          response => {
            console.log('api call success for mobile');
            setIsLoading(false);
            const message = response?.data?.message || '';
            if (response?.data?.status === 200) {
              setShowModal(true);
            } else {
              verifyEmailMobileNo(advocateData.mobileNo);
            }
            setEmailMobileExistsMessage(message);
          },
          err => {
            setIsLoading(false);
            console.log(err?.data?.message);
          },
          headers
        )
      );
    }
  };

  const checkEmailId = async () => {
    const requestData = {
      email: advocateData.email,
      phoneNumber: '',
      encryptedAdvocateCode: advocateData.encryptedAdvocateCode
        ? advocateData.encryptedAdvocateCode
        : '',
      isUpdate: advocateData.encryptedAdvocateCode ? true : false
    };
    setIsLoading(true);
    if (EmailOrMobileNoValidation()) {
      await dispatch(
        advocateEmailMobileValidationAPI(
          requestData,
          response => {
            console.log('api call success for email');
            setIsLoading(false);
            const message = response?.data?.message || '';
            if (response?.data?.status === 200) {
              setShowModal(true);
            } else {
              verifyEmailMobileNo(advocateData.email);
            }
            setEmailMobileExistsMessage(message);
          },
          err => {
            setIsLoading(false);
            console.log(err?.data.message);
          },
          headers
        )
      );
    }
  };

  const confirmEmailOrMobileNo = async () => {
    setShowModal(false);
    if (currentCheck === 'email') {
      setCurrentCheck('');
      await verifyEmailMobileNo(advocateData.email);
    } else if (currentCheck === 'mobileNo') {
      setCurrentCheck('');
      await verifyEmailMobileNo(advocateData.mobileNo);
    }
  };

  const verifyEmailMobileNo = async (emailOrMobileNo) => {
    setIsLoading(true);
    const requestData = {
      EncryptedAdvocateCode: advocateData.encryptedAdvocateCode,
      EmailOrMobileNo: emailOrMobileNo
    };
    await dispatch(
      verifyEmailMobileNoAPI(
        requestData,
        response => {
          setIsLoading(false);
          toast.success(`${response.data.message}`, {
            theme: 'colored',
            autoClose: 10000
          });
        },
        err => {
          setIsLoading(false);
          setFormError(true);
          console.log('Error for API:', err?.data.message);
        },
        headers
      )
    );
  };

  const EmailOrMobileNoValidation = () => {
    setIsLoading(false);
    const emailErr = {};
    const mobileNoErr = {};

    let isValid = true;

    if (!advocateData.mobileNo) {
      mobileNoErr.mobileNoErr = 'Enter mobile no';
      isValid = false;
    } else if (!/^(?!0)[0-9]{10}$/.test(advocateData.mobileNo)) {
      mobileNoErr.phoneInvalid =
        'Invalid mobile number, number should be of 10 digits should not start with 0';
      isValid = false;
    }

    if (!advocateData.email) {
      emailErr.empty = 'Enter email address';
      isValid = false;
    } else if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(advocateData.email)
    ) {
      emailErr.invalid = 'Please enter valid email address';
      isValid = false;
      setFormError(true);
    }

    setMobileNoErr(mobileNoErr);
    setEmailErr(emailErr);
    return isValid;
  };

  return (
    <>
      {/* {isLoading ? (
        <Spinner
      className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
          animation="border"
        />
      ) : null} */}
            {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

      {advocateData && (
        <Form
          noValidate
          validated={formHasError}
          className="details-form advocateProfile11"
          id="addAdvocateDetailsForm"
        >
          <FalconComponentCard className="farmer-card-row1 mb-2 advocateProfile2">
            <FalconComponentCard.Header
              title="Advocate Details"
              light={false}
              className='advocate-profile-card-header'
            />
            <FalconComponentCard.Body language="jsx">
              <Row className=''>
                <Col sm={6} lg={6} className="no-pd-card  ">
                  <Row >
                    <Col className="me-3 ms-3">
                      <Form.Group
                        as={Row}
                        // className="mb-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon bold-text">
                          <h5>Advocate Name<span className="text-danger tc-danger">*</span></h5><span className='advocate-profile-colum-2'>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtAdvocateName"
                            name="advocateName"
                            maxLength={50}
                            value={advocateData.advocateName}
                            onChange={handleFieldChange}
                            placeholder="Advocate Name"
                            required={true}

                            disabled
                          />
                          {Object.keys(advocateError.advocateNameErr).map(key => {
                            return (
                              <span className="error-message">
                                {advocateError.advocateNameErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="me-3 ms-3">
                      <Form.Group
                        as={Row}
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon bold-text ">
                          <Form.Label><h5>Contact Person</h5></Form.Label><span className='advocate-profile-colum-2'>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="contactPerson"
                            disabled
                            maxLength={50}

                            value={advocateData.contactPerson}
                            name="contactPerson"
                            onChange={handleFieldChange}
                            placeholder="Contact Person"
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="me-3 ms-3 advocate-billing">
                      <Form.Group
                        as={Row}
                        className=""
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon bold-text">
                          <Form.Label className='text-nowrap' ><h5>Advocate Billing Address</h5></Form.Label><span className='advocate-profile-colum-2'>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            name="advocateAddress1"
                            maxLength={200}
                            disabled
                            value={advocateData.advocateAddress1}
                            onChange={handleFieldChange}
                            className="mb-1"
                            placeholder="Address"
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="me-3 ms-3">
                      <Form.Group
                        as={Row}
                        className=""
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          <Form.Label></Form.Label>
                        </Form.Label>
                        <Col sm={8}>

                          <EnlargableTextbox
                            id="txtAdvocateAddress2"
                            name="advocateAddress2"
                            maxLength={200}
                            disabled
                            value={advocateData.advocateAddress2}
                            onChange={handleFieldChange}
                            className="mb-1"
                            placeholder="Address 2"
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="me-3 ms-3">
                      <Form.Group
                        as={Row}
                        className=""
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          <Form.Label></Form.Label>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtAdvocateAddress3"
                            name="advocateAddress3"
                            maxLength={200}
                            disabled
                            value={advocateData.advocateAddress3}
                            onChange={handleFieldChange}
                            className="mb-1"
                            placeholder="Address 3"
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="me-3 ms-3">
                      <Form.Group
                        as={Row}
                        className=""
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          <Form.Label></Form.Label>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtState"
                            name="stateCode"
                            className="mb-1"
                            disabled
                            value={advocateData.stateCode}
                            onChange={handleFieldChange}
                            required
                          >
                            <option value="">Select state</option>
                            {stateList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                          {Object.keys(advocateError.stateErr).map(key => {
                            return (
                              <span className="error-message">
                                {advocateError.stateErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="me-3 ms-3">
                      <Form.Group
                        as={Row}
                        className="mb-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          <Form.Label></Form.Label>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtCountry"
                            name="countryCode"
                            disabled

                            value={advocateData.countryCode}
                            onChange={handleFieldChange}
                            required
                          >
                            <option value="">Select country</option>
                            {countryList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="me-3 ms-3">
                      <Form.Group
                        as={Row}
                        className=""
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon bold-text">
                          <Form.Label><h5>GST No.</h5></Form.Label><span className='advocate-profile-colum-2'>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtGSTNo"
                            name="gstNo"
                            maxLength={15}
                            value={advocateData.gstNo}
                            onChange={handleFieldChange}
                            placeholder="GST No."
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
                <Col md={4} lg={4} className="no-pd-card  ">
                  <Col className="me-3 ms-3">
                    <Form.Group as={Row} controlId="formHorizontalEmail ">
                      <Form.Label column sm={4} className="label-with-colon bold-text">
                        <h5> Login User ID</h5><span></span>:
                      </Form.Label>
                      <Col sm={6}>
                        <EnlargableTextbox
                          id="txtLoginUSerID"
                          name="loginUserID"
                          maxLength={50}
                          disabled
                          value={advocateData.loginUserID}
                          onChange={handleFieldChange}
                          placeholder="Login User ID"
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col className="me-3 ms-3">
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={4} className="label-with-colon bold-text">
                        <h5> Start Date</h5><span></span>:
                      </Form.Label>
                      <Col sm={6}>
                        <EnlargableTextbox
                          id="txtStartDate"
                          name="startDate"
                          maxLength={50}
                          disabled
                          value={Moment(advocateData.startDate).format('DD-MM-YYYY')}
                          onChange={handleFieldChange}
                          placeholder="Start Date"
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                  <Col className="me-3 ms-3">
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={4} className="label-with-colon bold-text">
                        <h5> End Date</h5> <span>:</span>
                      </Form.Label>
                      <Col sm={6}>
                        <EnlargableTextbox
                          id="txtExpiryDate"
                          name="expiryDate"
                          maxLength={50}
                          disabled
                          value={Moment(advocateData.expiryDate).format('DD-MM-YYYY')}
                          onChange={handleFieldChange}
                          placeholder="End Date"
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Col>
                <Col md={2} className='bold-text'>
                  <Form.Label className='d-flex'><h5>My Picture</h5></Form.Label>
                  {advocateData?.advocatePicFileURL ? (
                    <>
                      <img
                        // src={advocateData.advocatePicFileURL}
                        src={imagePreview ||`${advocateData.advocatePicFileURL}?t=${Date.now()}`}
                        id="advocatePicUploadFile"
                        className="img-thumbnail shadow-sm logo-photo p3px"
                      />
                      <InputGroup className="mb-1 no-padding mt-1">
                        <Button onClick={() => document.getElementById('advocatePicFile').click()}>Change</Button>
                        <InputGroup.Text>
                          <FontAwesomeIcon
                            icon={'trash'}
                            onClick={() => setDeleteModal(true)}
                          />
                        </InputGroup.Text>
                      </InputGroup>
                    </>
                  ) : (
                    <Button onClick={() => document.getElementById('advocatePicFile').click()}>Upload</Button>
                  )}
                  {Object.keys(advocateError.advocatePicFileErr).map(key => (
                    <span className="error-message">{advocateError.advocatePicFileErr[key]}</span>
                  ))}
                  <Form.Control
                    type="file"
                    id="advocatePicFile"
                    name="advocatePicFile"
                    onChange={handleFieldChange}
                    hidden
                  />
                </Col>
              </Row>
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>

      )}
      {advocateData && (
        <Col sm={12} lg={12} className=" mb-2">
          <FalconComponentCard className="farmer-card-row1 advocate-profile-com-card">
            <FalconComponentCard.Header
              title="Communication Details"
              light={false}
              className='advocate-profile-card-header'
            />
            <FalconComponentCard.Body language="jsx">
              <Row>
                <Col sm={6} lg={6} className="no-pd-card">
                  <Row className="mb-3">
                    <Col>
                      <Form.Group as={Row} controlId="formHorizontalEmail">
                        <Form.Label column sm={4} className="label-with-colon bold-text">
                          <h5>Email ID</h5><span className="text-danger tc-danger1">*</span><span className='advocate-profile-colun'>:</span>
                        </Form.Label>
                        <Col sm={8} className="email-btn">
                          <EnlargableTextbox
                            id="txtEmail"
                            name="email"
                            maxLength={100}
                            value={advocateData.email}
                            onChange={handleFieldChange}
                            placeholder="Email ID"
                            required
                          />
                          <Button
                            className="btn-sm btn-primary"
                            onClick={() => {
                              checkEmailId();
                              setCurrentCheck('email');
                            }}
                            disabled={!isEmailChanged || !advocateData.email}
                          >
                            Verify
                          </Button>

                        </Col>
                        {Object.keys(emailErr).map((key) => (
                          <span key={key} className="error-message email-phone-validation-ap-err">
                            {emailErr[key]}
                          </span>
                        ))}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Form.Group as={Row} controlId="formHorizontalMobile">
                        <Form.Label column sm={4} className="label-with-colon bold-text">
                         <h5> Mobile No.</h5><span className="text-danger tc-danger2">*</span><span className='advocate-profile-colun'>:</span>
                        </Form.Label>
                        <Col sm={8} className="email-btn">
                          <EnlargableTextbox
                            id="txtMobileNo"
                            name="mobileNo"
                            maxLength={10}
                            value={advocateData.mobileNo}
                            onChange={handleFieldChange}
                            placeholder="Mobile No."
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            required
                          />
                          <Button
                            className="btn-sm btn-primary"
                            onClick={() => {
                              checkMobileNo();
                              setCurrentCheck('mobileNo');
                            }}
                            disabled={!isMobileNoChanged || !advocateData.mobileNo}
                          >
                            Verify
                          </Button>

                        </Col>
                        {Object.keys(mobileNoErr).map((key) => (
                          <span key={key} className="error-message email-phone-validation-ap-err">
                            {mobileNoErr[key]}
                          </span>
                        ))}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group as={Row} controlId="formHorizontalLandline">
                        <Form.Label column sm={4} className="label-with-colon bold-text">
                        <h5>Landline No.</h5><span className='advocate-profile-colun'>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtLandlineNo"
                            name="landlineNo"
                            maxLength={40}
                            value={advocateData.landlineNo}
                            onChange={handleFieldChange}
                            placeholder="Landline No."
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
                <Col sm={6} lg={6} className="no-pd-card">
                  <Row className="mb-3">
                    <Col>
                      <Form.Group as={Row} controlId="formHorizontalChamberNo">
                        <Form.Label column sm={4} className="label-with-colon bold-text">
                          <h5>Chamber No.</h5><span className='advocate-profile-colun'>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtChamberNo"
                            name="chamberNo"
                            className="profile-chamber"
                            maxLength={50}
                            value={advocateData.chamberNo}
                            onChange={handleFieldChange}
                            placeholder="Chamber No."
                          />
                          {Object.keys(advocateError.chamberNoErr).map((key) => (
                            <span key={key} className="error-message">
                              {advocateError.chamberNoErr[key]}
                            </span>
                          ))}
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className='profile-practice'>
                    <Col>
                      <Form.Group as={Row} controlId="formHorizontalPracticeSince">
                        <Form.Label column sm={4} className="label-with-colon bold-text">
                          <h5>Practice Since</h5><span className='advocate-profile-colun'>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtPracticeSince"
                            name="practiceSince"
                            maxLength={4}
                            value={advocateData.practiceSince}
                            onChange={handleFieldChange}
                            placeholder="Practice Since"
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                          {Object.keys(advocateError.practiceSinceErr).map((key) => (
                            <span key={key} className="error-message">
                              {advocateError.practiceSinceErr[key]}
                            </span>
                          ))}
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Col>
      )}

      {advocateData && (
        <Col sm={12} lg={12} className="no-pd-card">
          <FalconComponentCard className="farmer-card-row1 advocate-profile-others-card">
            <FalconComponentCard.Header
              title="Others"
              light={false}
              className='advocate-profile-card-header'
            />
            <FalconComponentCard.Body language="jsx">
              <Row>
                <Col sm={12} lg={12} className="no-pd-card  advocate-portal-col">
                  <Row>
                    <Col className=" me-5 ms-3">
                      <Form.Group
                        as={Row}
                        className=""
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={2} className="label-with-colon bold-text">
                          <Form.Label><h5>Advocate Portal URL</h5></Form.Label><span className='advocate-profile-colun'>:</span>
                        </Form.Label>
                        <Col sm={10} className='col-profile-textarea'>
                          <EnlargableTextbox
                            id="txtAdvocatePortalURl"
                            name="advocatePortalUrl"
                                className='profile-textarea'
                            maxLength={100}
                            value={advocateData.advocatePortalUrl}
                            onChange={handleFieldChange}
                            placeholder="Advocate Portal URL"
                          />
                                 {Object.keys(advocateError.advocatePortalUrlErr).map((key) => (
                            <span key={key} className="error-message">
                              {advocateError.advocatePortalUrlErr[key]}
                            </span>
                          ))}
                        </Col>
                      </Form.Group>
                    </Col>

                  </Row>

                </Col>
                <Col sm={12} lg={12} className="no-pd-card  advocate-profile-textarea">
                  <Row>
                    <Col className="me-5 ms-3">
                      <Form.Group
                        as={Row}
                        className=""
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={2} className="label-with-colon bold-text">
                          <Form.Label><h5>About Advocate</h5></Form.Label> <span className='advocate-profile-colun-about'>:</span>
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            id="txtClientProfile"
                            name="clientProfile"
                            className='profile-textarea'
                            as="textarea"
                            rows={5}
                            maxLength={200}
                            onChange={handleFieldChange}
                            value={advocateData.clientProfile}
                            placeholder="About Advocate"
                          />

                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Col>

      )}
      <ConfirmationModal
        show={showModal}
        onConfirm={confirmEmailOrMobileNo}
        onCancel={() => setShowModal(false)}
        message={emailMobileExistsMessage}
      />
      <DeleteImageConfirmationModal
        show={deleteModal}
        onConfirm={removeUploadFile}
        onCancel={() => setDeleteModal(false)}
      />
    </>
  );
};

export default ProfileDetail;